export enum SaleDocumentKind {
    Invoice = 'Invoice',
    VatMarginInvoice = 'VatMarginInvoice',
    ProForma = 'ProForma',
    Receipt = 'Receipt',
    AdvanceInvoice = 'AdvanceInvoice',
    InvoiceAdjustment = 'InvoiceAdjustment',
    VatMarginInvoiceAdjustment = 'VatMarginInvoiceAdjustment',
    ReceiptAdjustment = 'ReceiptAdjustment',
    AdvanceInvoiceAdjustment = 'AdvanceInvoiceAdjustment'
}
